import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDraws = function SvgDraws(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 50 16 86.787V144l64-36.787V50Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 130c27.89 0 50.5-22.61 50.5-50.5S107.39 29 79.5 29 29 51.61 29 79.5 51.61 130 79.5 130Z",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.522 90.478c0 6.06 4.918 10.979 10.978 10.979s10.978-4.918 10.978-10.978S85.56 79.5 79.5 79.5s-10.978-4.918-10.978-10.978S73.44 57.544 79.5 57.544s10.978 4.918 10.978 10.978M79.5 50.956v57.087",
    stroke: "#0C1733",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var Memo = /*#__PURE__*/memo(SvgDraws);

export { Memo as default };
//# sourceMappingURL=draws.svg.js.map
